







































































































import Vue from "vue";
import firebase from "@/plugins/firebase";
import "@/types";

export default Vue.extend({
  data: () => ({
    form: {
      firstName: "",
      lastName: "",
      password: "",
      passwordConfirm: "",
      email: ""
    },
    alert: false,
    message: "",
    error: false,
    confirm: false
  }),
  computed: {
    firstNameRules() {
      return [(v: string) => !!v || "Required"];
    },
    lastNameRules() {
      return [(v: string) => !!v || "Required"];
    },
    emailRules() {
      return [
        (v: string) => !!v || "Required",
        (v: string) => /.+@.+\..+/.test(v) || "Invalid e-mail"
      ];
    },
    passwordRules() {
      return [
        (v: string) => !!v || "Required",
        (v: string) =>
          /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[a-zA-Z]).{8,}$/gm.test(v) ||
          "Your password must be at least 8 characters. It must contain at least 1 uppercase letter, 1 lowercase letter and 1 number."
      ];
    },
    passwordConfirmRules() {
      return [
        (v: string) => !!v || "Please confirm the password",
        (v: string) =>
          v === this.form.password || "Password has not been confirmed."
      ];
    },
    confirmRules() {
      return [this.confirm || "Please confirm terms of use."];
    }
  },
  methods: {
    validate() {
      const form = this.$refs.form as HTMLFormElement;
      return form.validate();
    },
    reset() {
      const form = this.$refs.form as HTMLFormElement;
      form.reset();
    },
    resetValidation() {
      const form = this.$refs.form as HTMLFormElement;
      form.resetValidation();
    },
    signup() {
      if (this.validate()) {
        firebase
          .auth()
          .createUserWithEmailAndPassword(this.form.email, this.form.password)
          .then(userRef => {
            if (!userRef.user) return;

            // Update firebase auth profile
            userRef.user.updateProfile({
              displayName: `${this.form.firstName} ${this.form.lastName}`
            });

            const newUser: User = {
              id: userRef.user.uid,
              firstName: this.form.firstName,
              lastName: this.form.lastName,
              displayName: `${this.form.firstName} ${this.form.lastName}`,
              email: this.form.email,
              roles: ["student"]
            };

            firebase
              .firestore()
              .collection("users")
              .add({
                uid: newUser.id,
                firstName: newUser.firstName,
                lastName: newUser.lastName,
                email: newUser.email,
                roles: newUser.roles
              })
              .then(() => {
                this.$store.dispatch("auth/signIn", newUser);

                this.error = false;
                this.alert = true;
                this.message =
                  "Your account has been successfully created. Please wait...";

                this.$router.push({ name: "home-en" });
              })
              .catch(error => {
                throw `Your account could not be created: ${error}`;
              });
          })
          .catch(err => {
            this.error = true;
            this.alert = true;
            this.message = this.getErrorMessage(err.code);
          });
      }
    },
    getErrorMessage(code: string) {
      let msg = "";
      switch (code) {
        case "auth/email-already-in-use":
          msg = "This email address is already in use by another account.";
          break;
        case "auth/invalid-email":
          msg = "Invalid e-mail address.";
          break;
        case "auth/operation-not-allowed":
          msg = "You do not have permission to perform this operation.";
          break;
        case "auth/weak-password":
          msg =
            "Your password must be at least 8 characters. It must contain at least 1 uppercase letter, 1 lowercase letter and 1 number.";
          break;
        default:
          msg =
            "ERROR! User registration could not be completed. Please try again later.";
      }
      return msg;
    }
  }
});
